// extracted by mini-css-extract-plugin
module.exports = {"defectForm":"DefectForm_defectForm__2LLjc","formTypesList":"DefectForm_formTypesList__2bbD5"};